import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-shopping-cart-shipping-fee-progress',
  imports: [MatProgressBarModule, MatIconModule],
  templateUrl: './shopping-cart-shipping-fee-progress.html',
  styleUrl: './shopping-cart-shipping-fee-progress.scss',
})
export class ShoppingCartShippingFeeProgress implements OnChanges {
  @Input({ required: true }) subtotal: number = 0;
  progress: number = 0;
  left: string = '';

  get free_shipping_threshold() {
    return environment.free_shipping_threshold;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.progress = Math.floor(
      (this.subtotal / this.free_shipping_threshold) * 100,
    );
    this.left = Math.ceil(this.free_shipping_threshold - this.subtotal).toFixed(
      0,
    );
  }
}
